/* ═══ O JS DA PÁGINA DE PRODUTO — galeria, quantidade, kits, abas, FAQ, comparador, giro 3D e o botão de comprar ═══
   [2026-09-20] ERA INLINE no snippet ettore-produto-js, rendido em 4 seções do template (produto + 3 miolos): 4 × 42 KB de
   script no HTML de cada ficha (650 KB no total; medido). Agora é UM arquivo, cacheado, e cada seção deixa só um marcador
   `<span hidden data-produto-js>` logo depois da própria raiz — `liga(raiz)` roda para cada marcador. O guarda abaixo
   segura as 4 tags <script src> iguais (o navegador baixa uma vez e executaria quatro).
   ⚠️ O corpo de `liga` é o IIFE de sempre, palavra por palavra; `raiz` virou parâmetro. Quem editar aqui edita o snippet
   também? NÃO — o snippet agora só rende a tag e o marcador; a fonte da verdade é este arquivo. */
(function () {
  if (window.__ettoreProdutoJs) return;
  window.__ettoreProdutoJs = true;

  function liga(raiz) {
    if (!raiz) return;

    /* ---- galeria: thumb troca a foto ---- */
    var fotos = raiz.querySelector('[data-fotos]');
    var thumbs = raiz.querySelector('[data-thumbs]');
    var conta = raiz.querySelector('[data-foto-atual]');
    if (fotos && thumbs) {
      /* ---- [2026-09-19] o slide de VÍDEO toca só quando está na tela ----
         📏 Medido no tema de prova (1280 e 1680): <video autoplay muted loop playsinline> com readyState 4 e
           `paused: true` — o Chrome não dispara o autoplay de um vídeo fora da vista (o 5º slide fica a 2158 px
           à esquerda do quadro), e `play()` chamado à mão funcionava. Ele viu parado no computador.
         👉 Quem manda é a posição: entrou no quadro, `play()`; saiu, `pause()` (poupa dados e CPU). O `catch`
           vazio é para o iPhone em economia de bateria, que rejeita o play sem gesto — fica a capa, sem erro. */
      var vids = fotos.querySelectorAll('figure[data-video] video');
      if (vids.length && 'IntersectionObserver' in window) {
        var ioVid = new IntersectionObserver(function (ents) {
          for (var q = 0; q < ents.length; q++) {
            var vd = ents[q].target;
            if (ents[q].isIntersecting) { var pr = vd.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else vd.pause();
          }
        }, { root: fotos, threshold: 0.5 });
        for (var q2 = 0; q2 < vids.length; q2++) ioVid.observe(vids[q2]);
      }
      /* ---- a cor escolhida leva a galeria até a foto dela — [2026-08-29] ----
         🔴 O DEFEITO: escolher a base bege ou preta no Pendente Bolla não
           mexia na foto. Ele mostrou que no site PUBLICADO muda, e mostrou
           certo. Eu tinha dado o diagnóstico errado — disse que era foto
           faltando no catálogo, e é código: o evento `ettore:variante` já
           existia e ninguém escutava para trocar a imagem.
         🪤 E A VARIANTE MUITAS VEZES NÃO TEM FOTO PRÓPRIA: no Bolla, as três
           variantes de base preta não têm nenhuma; só as beges têm. Por isso o
           `null` não pode ser ignorado — ele significa "volte para a primeira
           foto do produto", que é exatamente o que o tema publicado faz, e é o
           que dá ao olho a sensação de que a foto trocou.
         📌 O ouvinte mora AQUI, junto da galeria, e não no ettore-opcoes.js:
           `fotos`, `thumbs` e `conta` já vivem neste escopo, e duplicar a
           rolagem no outro arquivo criaria o gêmeo que diverge na primeira
           mexida — como aconteceu com os mapas de cor. */
      /* [2026-09-12] a miniatura ativa num lugar só: a classe `on` na <img> (CSS) e o
         `aria-pressed` no <button> que a envolve (leitor de tela). Três caminhos
         marcavam a img cada um do seu jeito e nenhum falava com o botão. */
      function marcaThumb(i) {
        thumbs.querySelectorAll('img').forEach(function (x, k) { x.classList.toggle('on', k === i); });
        thumbs.querySelectorAll('.th').forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      }
      /* ═══ GALERIA POR COR — [2026-09-12]. Decisão dele: *"a 2 é o mais importante"* — a
         galeria inteira troca com a cor, como na Gantri (medida hoje: clicar "Carbon" troca as 5
         fotos). O Liquid desenha um conjunto de figuras por cor, cada uma com `data-cor`; aqui só
         se ESCONDE o que não é da cor escolhida (figura, miniatura e mini do ampliador) e se
         reconta. Índice GLOBAL (fotos.children, com as escondidas) para thumbs/ampliador; índice
         VISÍVEL só para o contador, as setas e a rolagem. Sem `data-cor` preenchido em nenhuma
         figura, nada muda: produto sem cor continua como sempre. */
      var total = raiz.querySelector('[data-foto-total]');
      function vis() { return [].filter.call(fotos.children, function (f) { return !f.hidden; }); }
      function corDe(v) {
        var grupos = raiz.querySelectorAll('[data-opcoes] .eop');
        for (var g = 0; g < grupos.length; g++) {
          var nome = (grupos[g].getAttribute('data-eop-nome') || '').toLowerCase();
          if (nome !== 'cor' && nome !== 'base' && nome !== 'tampo') continue; // [19/09] 'Tampo' = o fechamento de cima do pendente (era 'Base')
          if (v && v.op) return v.op[g] || '';
          var on = grupos[g].querySelector('.eop-bt.on');
          return on ? (on.getAttribute('data-val') || '') : '';
        }
        return '';
      }
      function aplicaCor(nome) {
        var temCor = false;
        [].forEach.call(fotos.children, function (f) {
          var c = f.getAttribute('data-cor') || '';
          if (c) temCor = true;
          f.hidden = !!(c && c !== nome);
        });
        if (!temCor) return false;
        raiz.querySelectorAll('[data-thumbs] .th, [data-zoom-mini] button').forEach(function (b) {
          var c = b.getAttribute('data-cor') || '';
          b.hidden = !!(c && c !== nome);
        });
        if (total) total.textContent = vis().length;
        return true;
      }
      function indiceVisivel() {
        var vs = vis(), i = 0;
        for (var k = 0; k < vs.length; k++) {
          if (Math.abs(vs[k].offsetLeft - fotos.offsetLeft - fotos.scrollLeft) < Math.max(1, vs[k].clientWidth / 2)) i = k;
        }
        return i;
      }
      function vaiParaFoto(i) {
        var alvo = fotos.children[i];
        if (!alvo) return;
        fotos.scrollTo({ left: alvo.offsetLeft - fotos.offsetLeft, behavior: 'smooth' });
        marcaThumb(i);
        if (conta) conta.textContent = vis().indexOf(alvo) + 1;
      }
      aplicaCor(corDe(null));
      raiz.addEventListener('ettore:variante', function (e) {
        var v = e.detail; if (!v) return;
        aplicaCor(corDe(v));
        var i = -1;
        if (v.img) {
          var fig = fotos.querySelector('figure[data-img="' + v.img + '"]');
          if (fig && !fig.hidden) i = [].indexOf.call(fotos.children, fig);
        }
        if (i < 0) { var p = vis()[0]; i = p ? [].indexOf.call(fotos.children, p) : 0; }
        vaiParaFoto(i);
      });

      thumbs.addEventListener('click', function (e) {
        /* `[data-i]` e não `img[data-i]`: pelo teclado o clique nasce no <button>, não na img */
        var t = e.target.closest('[data-i]');
        if (!t) return;
        var i = +t.dataset.i;
        var alvo = fotos.children[i];
        if (alvo) fotos.scrollTo({ left: alvo.offsetLeft - fotos.offsetLeft, behavior: 'smooth' });
        marcaThumb(i);
        if (conta && alvo) conta.textContent = vis().indexOf(alvo) + 1;
      });
      /* rolar a galeria também atualiza o contador e a miniatura ativa */
      var pendente;
      fotos.addEventListener('scroll', function () {
        clearTimeout(pendente);
        pendente = setTimeout(function () {
          var i = indiceVisivel();
          var fig = vis()[i];
          if (conta) conta.textContent = i + 1;
          if (fig) marcaThumb([].indexOf.call(fotos.children, fig));
        }, 90);
      }, { passive: true });

      /* as setas empurram a faixa em uma largura; o `scroll-snap` encaixa.
         🪤 DÁ A VOLTA NAS PONTAS, como no modal: seta que não faz nada na
           última foto parece quebrada. `scrollLeft` direto (sem `scrollBy`)
           porque na volta o destino é o começo, não um deslocamento. */
      var ant = raiz.querySelector('[data-gal-ant]');
      var prox = raiz.querySelector('[data-gal-prox]');
      function anda(passo) {
        var vs = vis(), n = vs.length;
        if (!n) return;
        var i = indiceVisivel();
        var d = (i + passo + n) % n;
        var alvo = vs[d];
        if (alvo) fotos.scrollTo({ left: alvo.offsetLeft - fotos.offsetLeft, behavior: 'smooth' });
      }
      if (ant) ant.addEventListener('click', function () { anda(-1); });
      if (prox) prox.addEventListener('click', function () { anda(1); });

      /* ---- ampliar a foto no clique — [2026-08-24] ----
         🪤 CLIQUE E ARRASTO CHEGAM PELO MESMO EVENTO. A faixa é arrastável com
           o dedo, e sem guarda toda rolagem terminaria abrindo o ampliador na
           cara dele. Aqui um movimento de mais de 8px desarma o clique — 8 e
           não 0 porque dedo parado ainda treme dois ou três pixels.
         🪤 A foto grande vem do `currentSrc` da PRÓPRIA galeria, já baixada e
           em cache: abrir é instantâneo e não custa download nenhum. Pedir uma
           largura diferente aqui furaria o cache e baixaria tudo de novo. */
      var zoom = raiz.querySelector('[data-zoom]');
      if (zoom && typeof zoom.showModal === 'function') {
        var zImg   = zoom.querySelector('[data-zoom-img]');
        var zPalco = zoom.querySelector('[data-zoom-palco]');
        var zMinis = zoom.querySelectorAll('[data-zoom-mini] button');

        function mostra(i) {
          var fonte = fotos.children[i] && fotos.children[i].querySelector('img');
          if (!fonte || !zImg) return;
          zoom.setAttribute('data-trocando', '');
          var pronta = new Image();
          pronta.onload = pronta.onerror = function () {
            zImg.src = pronta.src;
            zImg.alt = fonte.alt || '';
            if (pronta.naturalWidth) {
              zImg.width = pronta.naturalWidth;
              zImg.height = pronta.naturalHeight;
            }
            zoom.removeAttribute('data-trocando');
          };
          pronta.src = fonte.currentSrc || fonte.src;
          if (typeof solta === 'function') solta();   /* foto nova entra em 100% */
          for (var k = 0; k < zMinis.length; k++) {
            zMinis[k].classList.toggle('on', +zMinis[k].dataset.i === i);
          }
          zoom.dataset.i = i;
        }

        /* o clique na faixa, com a guarda do arrasto */
        var px = 0, py = 0, arrastou = false;
        fotos.addEventListener('pointerdown', function (e) {
          px = e.clientX; py = e.clientY; arrastou = false;
        }, { passive: true });
        fotos.addEventListener('pointermove', function (e) {
          if (Math.abs(e.clientX - px) > 8 || Math.abs(e.clientY - py) > 8) arrastou = true;
        }, { passive: true });
        fotos.addEventListener('click', function (e) {
          if (arrastou) return;
          var fig = e.target.closest('figure');
          if (!fig || fig.parentNode !== fotos) return;
          if (fig.hasAttribute('data-video')) return;   /* [19/09] o slide de vídeo não amplia: não há foto para mostrar */
          mostra([].indexOf.call(fotos.children, fig));
          zoom.showModal();
        });

        /* miniatura de dentro do ampliador troca a foto grande */
        if (zMinis.length) {
          zoom.addEventListener('click', function (e) {
            var b = e.target.closest('[data-zoom-mini] button');
            if (b) mostra(+b.dataset.i);
          });
        }

        /* fechar: o X, e o clique fora da foto.
           🪤 CLICAR FORA NÃO É SÓ CLICAR NO DIALOG. O palco ocupa a tela toda,
             então o vazio ao redor da foto é o `<figure>`, não o `<dialog>` —
             checar só `e.target === zoom` deixaria a maior parte do "fora"
             sem fechar nada. */
        zoom.addEventListener('click', function (e) {
          if (e.target.closest('[data-zoom-x]')) { zoom.close(); return; }
          if (moveu || escala > 1.02) return;   /* arrastando ou ampliada, não fecha */
          if (e.target === zoom || e.target === zPalco) zoom.close();
        });

        /* ---- o zoom de verdade: duplo-toque e pinça ----
           📏 POR QUE ISTO EXISTE. Medido logo depois de abrir o ampliador: no
             celular a foto "ampliada" saía com 343px contra 375px na página —
             ele ENCOLHIA a peça. E não era ajuste de padding: numa tela de
             390 a foto da galeria já ocupa quase a largura toda, então caber
             inteira na tela é o teto, e o teto é menor do que já era. Ampliar
             no celular só existe passando de 100%: é o que o gesto faz.
           🪤 O ARRASTO COM A FOTO AMPLIADA NÃO PODE FECHAR. O `click` que
             fecha ao tocar fora dispara igual no fim de um pan — sem a mesma
             guarda de movimento das fotos, mover a peça a fecharia na cara
             dele. Por isso `moveu` é consultado lá embaixo. */
        var escala = 1, tx = 0, ty = 0, moveu = false;
        var pontos = new Map(), base = 0, escala0 = 1;

        function aplica() {
          zImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + escala + ')';
          zoom.classList.toggle('perto', escala > 1.02);
        }
        function solta() { escala = 1; tx = 0; ty = 0; aplica(); }
        function limita() {
          /* a foto não pode ser arrastada para longe de si mesma: o excedente
             de cada lado é metade do que ela cresceu */
          var r = zImg.getBoundingClientRect();
          var maxX = Math.max(0, (r.width - zPalco.clientWidth) / 2);
          var maxY = Math.max(0, (r.height - zPalco.clientHeight) / 2);
          tx = Math.min(maxX, Math.max(-maxX, tx));
          ty = Math.min(maxY, Math.max(-maxY, ty));
        }

        if (zPalco && zImg) {
          zPalco.addEventListener('pointerdown', function (e) {
            pontos.set(e.pointerId, { x: e.clientX, y: e.clientY });
            moveu = false;
            if (pontos.size === 2) {
              var p = [].concat(Array.from(pontos.values()));
              base = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
              escala0 = escala;
            }
          });

          zPalco.addEventListener('pointermove', function (e) {
            if (!pontos.has(e.pointerId)) return;
            var antes = pontos.get(e.pointerId);
            pontos.set(e.pointerId, { x: e.clientX, y: e.clientY });

            if (pontos.size === 2 && base) {           /* pinça */
              var p = Array.from(pontos.values());
              var agora = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
              escala = Math.min(3, Math.max(1, escala0 * (agora / base)));
              moveu = true;
              limita(); aplica();
            } else if (pontos.size === 1 && escala > 1.02) {   /* arrastar */
              tx += e.clientX - antes.x;
              ty += e.clientY - antes.y;
              moveu = true;
              limita(); aplica();
            }
          });

          function largou(e) {
            pontos.delete(e.pointerId);
            if (pontos.size < 2) base = 0;
            if (escala <= 1.02) { escala = 1; tx = 0; ty = 0; aplica(); }
          }
          zPalco.addEventListener('pointerup', largou);
          zPalco.addEventListener('pointercancel', largou);

          /* duplo-toque / duplo-clique: 1× ⇄ 2,4× no ponto tocado */
          var ultimo = 0;
          zPalco.addEventListener('pointerup', function (e) {
            if (moveu || pontos.size) return;
            var agora = e.timeStamp;
            if (agora - ultimo < 320) {
              ultimo = 0;
              if (escala > 1.02) { solta(); }
              else {
                var r = zImg.getBoundingClientRect();
                escala = 2.4;
                tx = (r.left + r.width / 2 - e.clientX) * (escala - 1);
                ty = (r.top + r.height / 2 - e.clientY) * (escala - 1);
                limita(); aplica();
              }
            } else { ultimo = agora; }
          });
        }

        /* setas do teclado andam pelas fotos com o ampliador aberto */
        zoom.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var n = fotos.children.length;
          if (n < 2) return;
          e.preventDefault();
          /* [2026-09-20] pula o que não tem foto (o slide de vídeo travava as setas — medido: 11 setas presas na mesma foto)
             e as figuras escondidas de OUTRA cor (auditoria 14/09: "setas mostram a foto da outra cor") */
          var i = +zoom.dataset.i || 0, dir = e.key === 'ArrowRight' ? 1 : -1;
          for (var k = 0; k < n; k++) {
            i = (i + dir + n) % n;
            var fg = fotos.children[i];
            if (fg && !fg.hidden && fg.querySelector('img')) { mostra(i); break; }
          }
        });

        /* ao fechar, a galeria fica na foto que ele estava vendo — senão ele
           volta para a primeira e perde o lugar. Sem animação: o movimento
           aconteceu atrás de uma camada que já sumiu. */
        zoom.addEventListener('close', function () {
          solta();
          var alvo = fotos.children[+zoom.dataset.i || 0];
          if (alvo) fotos.scrollTo({ left: alvo.offsetLeft - fotos.offsetLeft, behavior: 'instant' });
        });
      }
    }

    /* ---- a descrição do comparador dobra — [2026-08-24] ----
       ⚠️ O BOTÃO NASCE ESCONDIDO e só aparece se houver o que revelar. Peça de
         descrição curta não ganha um "Ler mais" que abre nada — e a conta é
         feita com a caixa FECHADA, comparando o conteúdo real com a altura
         visível. Uma folga de 8px evita botão por causa de meia linha. */
    var dobra = raiz.querySelector('[data-dobra]');
    if (dobra) {
      var caixa = dobra.querySelector('.desc-caixa');
      var bt = dobra.querySelector('[data-desc-mais]');
      var texto = dobra.querySelector('.desc');
      if (caixa && bt && texto) {
        var confere = function () {
          if (dobra.hasAttribute('data-aberto')) return;
          var cabe = texto.scrollHeight <= caixa.clientHeight + 8;
          bt.hidden = cabe;
        };
        confere();
        /* a descrição tem imagens e fontes que chegam depois e mudam a altura */
        window.addEventListener('load', confere);
        if (window.ResizeObserver) new ResizeObserver(confere).observe(texto);

        bt.addEventListener('click', function () {
          var aberto = dobra.hasAttribute('data-aberto');
          if (aberto) dobra.removeAttribute('data-aberto');
          else dobra.setAttribute('data-aberto', '');
          bt.setAttribute('aria-expanded', aberto ? 'false' : 'true');
          bt.textContent = aberto ? 'Ler mais' : 'Ler menos';
        });
      }
    }

    /* ---- quantidade ---- */
    var campo = raiz.querySelector('[data-qtd]');
    if (campo) {
      var passo = function (d) { campo.value = Math.max(1, (+campo.value || 1) + d); };
      var menos = raiz.querySelector('[data-menos]');
      var mais = raiz.querySelector('[data-mais]');
      if (menos) menos.addEventListener('click', function () { passo(-1); });
      if (mais) mais.addEventListener('click', function () { passo(1); });
    }

    /* ---- kits: escolher troca a variante do form ---- */
    var kits = raiz.querySelector('[data-kits]');
    var idVar = raiz.querySelector('[data-id-variante]');
    /* [2026-09-13] O CONJUNTO É UM CONTROLE DE TECLADO — auditoria do Codex, ponto 16: as opções
       `.kit` eram divs com clique; quem navega por teclado não conseguia escolher o combo, que muda
       preço e variante. Agora são `role="radio"` com tabindex (no Liquid), aria-checked acompanha a
       classe `on`, e Enter/Espaço equivalem ao clique. As pílulas de modelo dentro do kit já eram
       botões e continuam com o próprio Enter. */
    if (kits) kits.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var k = e.target.closest('.kit');
      if (!k || e.target !== k) return;
      e.preventDefault();
      k.click();
    });
    if (kits && idVar) kits.addEventListener('click', function (e) {
      var k = e.target.closest('.kit');
      if (!k) return;
      kits.querySelectorAll('.kit').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
      k.classList.add('on');
      k.setAttribute('aria-checked', 'true');
      idVar.value = k.dataset.variante;

      /* [2026-09-06] Ele: "vou de uma peça para duas peças e o cashback não atualiza".
         📏 Medido: até aqui o clique só trocava a variante do FORM — o carrinho recebia
           a certa, e a tela continuava com o preço, o Pix, a parcela e o cashback da
           peça avulsa. Quem repinta esses quatro é o motor de OPÇÕES, que escuta
           `.eop-bt`; o kit não é uma opção, então nada era chamado.
         🔑 Os valores vêm prontos do Liquid nos data- do próprio kit — a regra dos 5%,
           dos 4x e dos 10% continua num lugar só, no Liquid. Aqui é só cópia.
         🪤 Os alvos são os MESMOS `data-eop-*` do motor de opções: escrever em outro
           lugar deixaria os dois discordando na mesma tela. */
      var escopo = raiz.querySelector('[data-eop-escopo]') || raiz;
      [['preco', '[data-eop-preco]'], ['pix', '[data-eop-pix]'],
       ['parc', '[data-eop-parc]'], ['volta', '[data-eop-volta]']].forEach(function (par) {
        var valor = k.dataset[par[0]];
        var alvo = escopo.querySelector(par[1]);
        if (valor && alvo) alvo.textContent = valor;
      });

      /* o riscado: o kit de combo traz a soma das peças pelo preço CHEIO (data-de);
         a peça avulsa não traz nada, e aí o riscado dela volta ao que o Liquid escreveu. */
      /* [2026-09-21] Revisão adversarial do Codex: o `eopOriginal` é o riscado da CARGA (cor inicial). Depois
         de uma troca de cor, quem sabe o riscado certo da peça avulsa é o `data-de` que o motor de opções
         escreve na pílula — presente e vazio quer dizer "esta cor não tem riscado". Só sem o atributo
         (nenhuma troca de cor ainda) é que vale o guardado. O selo, logo abaixo, segue a mesma regra. */
      var de = escopo.querySelector('[data-eop-de]');
      var temDe = 'de' in k.dataset;
      if (de) {
        if (k.dataset.de) { de.textContent = k.dataset.de; de.hidden = false; }
        else if (temDe) { de.hidden = true; }
        else if (de.dataset.eopOriginal) { de.textContent = de.dataset.eopOriginal; de.hidden = false; }
      }
      /* 🔴 [2026-09-20] O SELO "−X%" TAMBÉM ACOMPANHA O KIT. Medido: Kyoto com o trio (R$ 809 de R$ 1.007 = −20%)
         mostrava "−16%", o da peça avulsa — auditoria de 14/09. O % sai do riscado e do preço do próprio kit;
         ao voltar para "só esta peça", volta o que o Liquid escreveu. */
      escreveOff(escopo, k.dataset.de ? k.dataset.de : (temDe ? '' : null), k.dataset.preco);
    });
    function dinheiro(t) { return parseFloat(String(t || '').replace(/[^\d,]/g, '').replace(',', '.')) || 0; }
    function escreveOff(escopo, deTxt, precoTxt) {
      var off = escopo.querySelector('[data-eop-off]'); if (!off) return;
      if (off.dataset.eopOriginal === undefined) { off.dataset.eopOriginal = off.hidden ? '' : off.textContent.trim(); }
      if (deTxt === null) { off.textContent = off.dataset.eopOriginal; off.hidden = !off.dataset.eopOriginal; return; }
      if (deTxt === '') { off.hidden = true; return; }   /* a cor escolhida não tem riscado: sem selo */
      var d = dinheiro(deTxt), p = dinheiro(precoTxt);
      var pct = d > p && d > 0 ? Math.round((d - p) / d * 100) : 0;
      off.textContent = '−' + pct + '%'; off.hidden = !pct;
    }

    /* guarda o riscado que o Liquid escreveu, para poder voltar a ele */
    if (kits) {
      var deIni = raiz.querySelector('[data-eop-de]');
      if (deIni && !deIni.hidden) deIni.dataset.eopOriginal = deIni.textContent.trim();
    }

    /* ---- [2026-09-11] O KIT POR VARIANTE (a Dupla de Pendentes) SEGUE A OPÇÃO ----
       O Liquid deixa em `data-kit-mapa` a variante da Dupla para cada fio|base deste
       modelo. Quando o motor de opções avisa (`ettore:variante`, com `op`), o kit troca
       de variante, preço e riscado; se ele estiver marcado, o formulário e os quatro
       valores da tela vão junto — senão a pessoa escolhia "2m" e levava a dupla de 1m. */
    /* [2ª volta, mesmo dia] Ele: *"no mesmo card, um 'monte sua dupla'"*. O card tem as
       pílulas de modelo; a chave do mapa é modelo|fio|base. `data-kit-chave` guarda o
       fio|base atual (vem do Liquid e é reescrito a cada `ettore:variante`), para a pílula
       poder recalcular sem esperar uma troca de opção. */
    function aplicaKitMapa(k, chaveOp) {
        var mapa; try { mapa = JSON.parse(k.dataset.kitMapa); } catch (_) { return; }
        if (chaveOp) k.dataset.kitChave = chaveOp;
        var chave = (k.dataset.kitModelo || '') + '|' + (k.dataset.kitChave || '');
        var m = mapa[chave]; if (!m) return;
        k.dataset.variante = m.id; k.dataset.preco = m.preco; k.dataset.pix = m.pix;
        k.dataset.parc = m.parc; k.dataset.volta = m.volta; k.dataset.de = m.de;
        if (k.dataset.url) k.dataset.url = k.dataset.url.replace(/\?variant=\d+/, '?variant=' + m.id);
        var vb = k.querySelector('.v b'); if (vb) vb.textContent = m.preco;
        var vs = k.querySelector('.v s'), vi = k.querySelector('.v i');
        if (vs) vs.textContent = m.de; if (vi) vi.textContent = '− ' + m.eco;
        if (k.classList.contains('on') && idVar) {
          idVar.value = m.id;
          var escopo = raiz.querySelector('[data-eop-escopo]') || raiz;
          [['preco', '[data-eop-preco]'], ['pix', '[data-eop-pix]'], ['parc', '[data-eop-parc]'], ['volta', '[data-eop-volta]']].forEach(function (par) {
            var alvo = escopo.querySelector(par[1]); if (alvo) alvo.textContent = m[par[0]];
          });
          var de = escopo.querySelector('[data-eop-de]'); if (de) { de.textContent = m.de; de.hidden = false; }
          escreveOff(escopo, m.de, m.preco);
        }
    }
    if (kits) raiz.addEventListener('ettore:variante', function (e) {
      var v = e.detail; if (!v || !v.op) return;
      kits.querySelectorAll('.kit[data-kit-mapa]').forEach(function (k) { aplicaKitMapa(k, v.op.join('|')); });
    });
    /* a pílula de modelo: marca, troca o modelo do card e recalcula; o clique também
       marca o card (sobe até o handler dos kits, que lê o data-variante já trocado) */
    if (kits) kits.addEventListener('click', function (e) {
      var bt = e.target.closest('[data-kit-modelo-bt]'); if (!bt) return;
      var k = bt.closest('.kit[data-kit-mapa]'); if (!k) return;
      k.querySelectorAll('[data-kit-modelo-bt]').forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      bt.classList.add('on'); bt.setAttribute('aria-pressed', 'true');
      k.dataset.kitModelo = bt.dataset.kitModeloBt;
      aplicaKitMapa(k);
    }, true);   /* captura: roda ANTES do handler que marca o card, para ele copiar os valores novos */

    /* ---- as três abas de conteúdo: tocam e trocam sozinhas ----
       Ele apontou em 16/08: "não está animado e nem aparece a imagem, e não
       ficou trocando". Eram três coisas ao mesmo tempo — o vídeo nunca
       recebia play(), nada trocava de aba, e a barra de progresso era um
       enfeite parado.

       ⚠️ VÍDEO SÓ TOCA O DA ABA ATIVA. Três vídeos rodando ao mesmo tempo
         gastam banda e bateria para mostrar dois que ninguém está vendo; e no
         iPhone o terceiro simplesmente não começa.
       ⚠️ E o play() DEVOLVE UMA PROMESSA que rejeita quando o navegador
         recusa o autoplay. Sem o catch, isso vira um erro não tratado no
         console a cada troca de aba.
       🪤 A duração vem do próprio vídeo quando ele já sabe; sem isso, 6s. Um
         valor fixo faria a barra terminar antes ou depois do fim do vídeo. */
    /* ---- trava, preenche, troca, solta ----
       [2026-08-21] · terceira volta do bloco no mesmo dia, agora com o desenho
       dele por cima de um print do site. Nas palavras dele: *"ele aparece com a
       foto um quando entra nesse bloco, ele trava, e aí vai descendo, a barra
       vai preenchendo, muda pra foto dois… quando chega no final da barra, ele
       solta a página."*

       🔴 SAIU UM RELÓGIO, ENTROU A ROLAGEM — e continua valendo das versões
         anteriores: o trilho de 180vh e o `position:sticky` JÁ EXISTIAM no CSS,
         mas o conteúdo trocava com `setTimeout` de 3,5s, então mais de mil
         pixels de rolagem passavam por baixo do bloco sem mover nada.

       🪤 O TRILHO É DIVIDIDO EM FATIAS IGUAIS, uma por passo, e a última fatia
         precisa encher ATÉ O FIM antes de o bloco soltar. Por isso a conta é
         `t * n` e não `t * (n-1)`: com `n-1` o último passo ficaria ativo sem
         nunca preencher a linha dele, e o bloco se soltaria com a barra pela
         metade — exatamente o oposto do que ele descreveu.

       🪤 `transform:scaleY`, NUNCA `height`, para preencher a linha. Regra dura
         do projeto: animar propriedade de layout recalcula a página a cada
         quadro.
    */
    var abas = raiz.querySelector('[data-abas]');
    var trilho = raiz.querySelector('[data-abascroll]');
    if (abas && trilho) {
      var passos = abas.querySelectorAll('.abapasso');
      var mds = abas.querySelectorAll('.abacam');
      var n = passos.length;
      var atualAba = -1;
      var pedido = null;
      var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function tocaVideo(i) {
        /* 🪤 O PLAY É O DOWNLOAD — [2026-08-29]. `pinta()` roda na carga com a
           página no topo, `atualAba` nasce em -1, e o play do passo 0 fazia o
           navegador baixar os 121 KB do vídeo com as abas a milhares de pixels
           dali. Perto de verdade (1,5 tela) o play sai; longe, só a classe —
           e o `pinta()` de cada scroll re-chama quando a pessoa chega. */
        var perto = abas.getBoundingClientRect().top < window.innerHeight * 1.5;
        mds.forEach(function (m) {
          var ativo = parseInt(m.getAttribute('data-i'), 10) === i;
          m.classList.toggle('on', ativo);
          if (m.tagName === 'VIDEO') {
            /* ⚠️ Vídeo fora de vista é banda gasta à toa, e no celular pesa.
               Só toca o do passo em que a pessoa está. */
            if (ativo && perto) { var pr = m.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else if (!ativo && !m.paused) m.pause();
          }
        });
      }

      function pinta() {
        pedido = null;
        var r = trilho.getBoundingClientRect();
        var curso = trilho.offsetHeight - abas.offsetHeight;
        if (curso <= 0 || !n) return;

        /* 🪤 O DESLOCAMENTO DO `sticky` ENTRA NA CONTA — [2026-08-21]. O painel
           não gruda mais em `top:0`: no computador ele gruda em `top:130px`,
           abaixo do cabeçalho fixo (era `padding-top:146px`, que aparecia como
           um buraco branco de 172px entre o título e a foto no instante em que
           o bloco entra). Com deslocamento, `-r.top` erra por exatamente esses
           130px: a barra começaria a encher antes de o painel grudar e chegaria
           ao fim 130px cedo. Lendo o `top` computado, a mesma conta serve para
           as duas telas — no celular ele é 0 e nada muda. */
        var topo = parseFloat(getComputedStyle(abas).top) || 0;
        var t = Math.min(Math.max((topo - r.top) / curso, 0), 1);
        var tt = t * n;                                   /* 0 … n */
        var i = Math.min(Math.floor(tt), n - 1);

        passos.forEach(function (li, k) {
          li.classList.toggle('on', k === i);
          /* já passou → cheia; ainda não chegou → vazia; a do passo atual
             mostra a fração andada dentro da fatia dele */
          var f = Math.min(Math.max(tt - k, 0), 1);
          if (calmo) f = f >= 1 ? 1 : (k === i ? 1 : 0);  /* sem barra correndo */
          var barra = li.querySelector('.abalinha i');
          if (barra) barra.style.transform = 'scaleY(' + f + ')';
        });

        if (i !== atualAba) { atualAba = i; tocaVideo(i); }
        else {
          /* o passo não mudou, mas o vídeo dele pode estar esperando a pessoa
             chegar (ver tocaVideo): pausado e perto, liga */
          var vAtivo = null;
          mds.forEach(function (m) { if (m.tagName === 'VIDEO' && parseInt(m.getAttribute('data-i'), 10) === i) vAtivo = m; });
          if (vAtivo && vAtivo.paused && r.top < window.innerHeight * 1.5) tocaVideo(i);
        }
      }

      function agenda() {
        if (pedido === null) pedido = requestAnimationFrame(pinta);
      }

      window.addEventListener('scroll', agenda, { passive: true });
      window.addEventListener('resize', agenda);
      pinta();
    }

    /* 🔴 O BOTÃO DA FAIXA "Pronta para ir" SAIU EM [2026-08-22]. O desenho dele
       não tem botão nenhum ali, e a barra fixa do produto acompanha a página
       inteira com o mesmo "Adicionar ao carrinho" a 60px daquele canto.
       O gancho que morava aqui clicava no `[data-add-carrinho]` da zona de
       compra — nunca postava no `/cart/add.js` por conta própria, porque um
       segundo lugar montando o pedido ignora a variante escolhida no seletor.
       Se o botão voltar, é esse o desenho a refazer. */

    /* ---- as abas do FAQ ----
       Três grupos, um visível por vez. `hidden` em vez de classe: é o
       atributo que o navegador já entende, então leitor de tela e busca do
       navegador (Ctrl+F) pulam o que está fechado, em vez de encontrar texto
       que a pessoa não está vendo. */
    var faqtabs = raiz.querySelector('[data-faqtabs]');
    if (faqtabs) {
      faqtabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-faqtab]');
        if (!b) return;
        var alvo = b.dataset.faqtab;
        faqtabs.querySelectorAll('[data-faqtab]').forEach(function (x) {
          x.classList.toggle('on', x === b);
        });
        faqtabs.querySelectorAll('[data-faqtab]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');   /* [2026-09-12] estado para o leitor de tela */
        });
        raiz.querySelectorAll('[data-faqgrupo]').forEach(function (g) {
          g.hidden = g.dataset.faqgrupo !== alvo;
          /* fecha o que estava aberto no grupo que sai, senão a pessoa volta
             à aba e encontra respostas abertas que ela não abriu */
          if (g.hidden) g.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        });
      });
    }

    /* ---- [2026-09-11] o dia/noite DA GALERIA: um toque na pílula acende ----
       Mesma mescla por opacidade do comparador, sem slider: dentro do carrossel o
       arrasto horizontal já é da faixa. `stopPropagation` porque o clique na figura
       abre o ampliador (handler na faixa), e este botão não é foto. */
    /* 🔴 SÓ O PRIMEIRO COMPARADOR RECEBIA O OUVINTE — [2026-09-13], ponto 01 da auditoria do
       Codex, reproduzido na Nara: com Base Bege escolhida, o toque na pílula abria o AMPLIADOR.
       A galeria por cor (12/09) desenha um conjunto de slides por cor, e cada conjunto tem o seu
       `[data-duo]`; `querySelector` pegava só o da 1ª cor. Agora todos — o dia/noite continua
       UM só (unificado, decisão dele), mas o botão funciona em qualquer cor. */
    raiz.querySelectorAll('[data-duo]').forEach(function (duo) {
      var duoBt = duo.querySelector('[data-duo-bt]');
      if (!duoBt) return;
      /* 🔴 A PÍLULA TEM CARA DE SLIDER, ENTÃO TEM DE ARRASTAR — [2026-09-30]. O sócio tentou arrastar e nada;
         ele: *"quero que seja o botão arrastar mesmo… igual está, só que conseguir arrastar com o dedo"*.
         Medido antes: arrasto de 120px na bolinha = nada; só o toque acendia. Agora o dedo na pílula mistura
         dia e noite na hora (opacidade da `.nt` = posição no trilho) e, ao soltar, assenta no lado mais perto.
         `touch-action:none` (CSS) + `stopPropagation` para a faixa do carrossel não levar o gesto; o toque
         simples continua sendo o `click` abaixo. */
      var nt = duo.querySelector('img.nt'), mk = duo.querySelector('.mk2'), tri = duo.querySelector('.ptrilho');
      var arr = null, arrastou = false;
      var fracDe = function (x) { var r = tri.getBoundingClientRect(); return Math.max(0, Math.min(1, (x - r.left) / r.width)); };
      var pinta = function (f) {
        if (nt) { nt.style.transition = 'none'; nt.style.opacity = f; }
        if (mk) { mk.style.transition = 'none'; mk.style.left = (8 + 84 * f) + '%'; }
      };
      var solta = function () { if (nt) { nt.style.transition = ''; nt.style.opacity = ''; } if (mk) { mk.style.transition = ''; mk.style.left = ''; } };
      var marca = function (on) {
        duo.classList.toggle('acesa', on); duo.classList.add('mexeu');
        duoBt.setAttribute('aria-pressed', on ? 'true' : 'false');
        duoBt.setAttribute('aria-label', on ? 'Apagar a peça' : 'Acender a peça');
      };
      if (tri) {
        duoBt.addEventListener('pointerdown', function (e) {
          e.stopPropagation();
          arr = { x: e.clientX, f: duo.classList.contains('acesa') ? 1 : 0 }; arrastou = false;
          try { duoBt.setPointerCapture(e.pointerId); } catch (_) {}
        });
        duoBt.addEventListener('pointermove', function (e) {
          if (!arr) return;
          e.stopPropagation();
          if (!arrastou && Math.abs(e.clientX - arr.x) < 4) return;
          arrastou = true; e.preventDefault();
          arr.f = fracDe(e.clientX); pinta(arr.f); duo.classList.add('mexeu');
        });
        var fim = function (e) {
          if (!arr) return;
          e.stopPropagation();
          if (arrastou) { var on = arr.f >= 0.5; solta(); marca(on); }
          arr = null;
        };
        duoBt.addEventListener('pointerup', fim);
        duoBt.addEventListener('pointercancel', function (e) { if (arr && arrastou) { solta(); marca(arr.f >= 0.5); } arr = null; });
        ['touchstart', 'touchmove'].forEach(function (t) { duoBt.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true }); });
      }
      duoBt.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        if (arrastou) { arrastou = false; return; }
        var on = !duo.classList.contains('acesa');
        duo.classList.toggle('acesa', on); duo.classList.add('mexeu');
        duoBt.setAttribute('aria-pressed', on ? 'true' : 'false');
        duoBt.setAttribute('aria-label', on ? 'Apagar a peça' : 'Acender a peça');
      });
    });

    /* ---- comparador dia/noite: o slider revela a foto acesa ---- */
    var comp = raiz.querySelector('[data-comp]');
    if (comp) {
      var sl = comp.querySelector('[data-slider]');
      var noite = comp.querySelector('.nt');
      var mk = comp.querySelector('[data-mk]');
      var revela = function () {
        var p = +sl.value;
        /* ⚠️ MESCLA, NÃO CORTA — pedido dele em 16/08, com estas palavras:
           "como se fosse mesclando uma imagem na outra, elas estão
           posicionadas no mesmo lugar, é a mesma foto, só que uma foi tirada
           de dia e a outra de noite, e aí vai trocando — não uma camada preta
           por cima".

           Era clip-path: a foto de noite entrava recortada na vertical, e o
           que se via era metade de um ambiente colada na metade do outro, com
           uma emenda no meio. Como as duas fotos são o MESMO enquadramento,
           a emenda não revelava nada — só riscava a foto ao meio.

           Agora é opacidade: a noite atravessa a de dia por inteiro, sem
           corte e sem borda. Arrastar o dedo acende o ambiente todo de uma
           vez, que é o que a peça faz na casa da pessoa.

           🪤 clipPath tem de ser LIMPO na mão. Ele já esteve escrito no style
             inline destas fotos, e style inline não se apaga sozinho quando o
             JS troca de estratégia — a foto continuaria recortada por um valor
             que ninguém mais atualiza. */
        if (noite) { noite.style.clipPath = 'none'; noite.style.opacity = p / 100; }
        if (mk) mk.style.left = p + '%';
      };
      if (sl) { sl.addEventListener('input', revela); revela(); }

      /* ⚠️ ARRASTAR EM QUALQUER PONTO DA FOTO, e não só na bolinha.
         Ele apontou em 16/08: "não consigo pegar a bolinha e arrastar, só se
         eu clico em cima de cada parte". O input range existe e funciona,
         mas ele é invisível por cima da imagem — para pegá-lo é preciso
         acertar o polegar, que tem uns 20px, num gesto feito com o dedo numa
         foto de 390px. Na prática ninguém acerta.

         Agora o dedo comanda de onde estiver: o toque começa em qualquer
         lugar da foto e o corte segue o dedo. O input continua ali, e continua
         funcionando pelo teclado — é o que dá a seta esquerda/direita para
         quem não usa toque.

         🪤 setPointerCapture é o que faz o arrasto continuar quando o dedo
           sai da foto no meio do gesto. Sem ele o comparador "solta" no meio
           e a pessoa precisa recomeçar. */
      var arrastaComp = function (e) {
        var r = comp.getBoundingClientRect();
        var p = ((e.clientX - r.left) / r.width) * 100;
        p = Math.max(0, Math.min(100, p));
        if (sl) sl.value = p;
        revela();
      };
      comp.addEventListener('pointerdown', function (e) {
        /* não sequestra o toque de quem está rolando a página na vertical */
        if (e.pointerType === 'touch' && Math.abs(e.movementY) > Math.abs(e.movementX)) return;
        comp.setPointerCapture(e.pointerId);
        comp.dataset.arrastando = '1';
        arrastaComp(e);
      });
      comp.addEventListener('pointermove', function (e) {
        if (comp.dataset.arrastando) { e.preventDefault(); arrastaComp(e); }
      });
      var soltaComp = function (e) {
        delete comp.dataset.arrastando;
        if (comp.hasPointerCapture && comp.hasPointerCapture(e.pointerId)) comp.releasePointerCapture(e.pointerId);
      };
      comp.addEventListener('pointerup', soltaComp);
      comp.addEventListener('pointercancel', soltaComp);
    }

    /* ---- giro 3D: arrastar troca o quadro ----
       🪤 [2026-09-12] `mostra` e `base` eram os MESMOS nomes do ampliador, 500 linhas acima, no
         mesmo escopo de função: `var mostra = function` aqui REESCREVIA o `function mostra(i)`
         do ampliador (declaração em bloco é içada para a função), e numa ficha com giro as
         miniaturas do ampliador passavam a girar a peça. Nomes próprios: mostraQuadro/quadroBase. */
    var giro = raiz.querySelector('[data-giro]');
    if (giro) {
      var qs = giro.querySelectorAll('.gq');
      if (qs.length) {
        qs[0].classList.add('on');
        var atual = 0, arrastando = false, x0 = 0, quadroBase = 0;
        var mostraQuadro = function (i) {
          i = ((i % qs.length) + qs.length) % qs.length;
          if (i === atual) return;
          qs[atual].classList.remove('on');
          qs[i].classList.add('on');
          atual = i;
        };
        var comeca = function (x) { arrastando = true; x0 = x; quadroBase = atual; };
        var move = function (x) {
          if (!arrastando) return;
          /* a peça dá uma volta inteira ao arrastar a largura do quadro */
          mostraQuadro(quadroBase + Math.round((x - x0) / giro.clientWidth * qs.length));
        };
        var acaba = function () { arrastando = false; };
        giro.addEventListener('pointerdown', function (e) { comeca(e.clientX); giro.setPointerCapture(e.pointerId); });
        giro.addEventListener('pointermove', function (e) { move(e.clientX); });
        giro.addEventListener('pointerup', acaba);
        giro.addEventListener('pointercancel', acaba);
        /* teclado: seta gira um quadro por vez */
        giro.tabIndex = 0;
        giro.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { mostraQuadro(atual + 1); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { mostraQuadro(atual - 1); e.preventDefault(); }
        });
      }
    }

    /* ---- "Adicionar ao carrinho" abre a gaveta em vez de trocar de página.
            O botão COMPRAR (name=checkout) NÃO é interceptado: ele tem de
            seguir o caminho normal do form, que é o que o Yampi engancha. ---- */
    var form = raiz.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('submit', function (e) {
      /* 🪤 Qual botão enviou o form é `e.submitter` — não `document.activeElement`.
         O activeElement só é o botão se o navegador tiver dado foco a ele, e o
         Safari não dá foco em botão ao clicar. Com activeElement, "Adicionar ao
         carrinho" recarregava a página em vez de abrir a gaveta, de forma
         intermitente e dependente do navegador — o pior tipo de defeito. */
      var quem = e.submitter || document.activeElement;
      if (!quem || quem.name !== 'add') return;

      /* COMPRAR (data-comprar) põe no carrinho e vai para /cart, que é onde o
         Yampi assume. "Adicionar ao carrinho" põe e abre a gaveta, sem sair. */
      var comprar = quem.hasAttribute('data-comprar');
      var gaveta = document.querySelector('cart-drawer');
      if (!comprar && (!gaveta || typeof gaveta.open !== 'function')) return;

      e.preventDefault();
      quem.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          /* [2026-10-19] sem fio: as caixas marcadas (cúpula e cabo USB-C, ettore-cupula-extra) vão juntas, num segundo envio.
             ponytail: se uma falhar (esgotada), a Shopify recusa as duas; a luminária fica e a gaveta mostra sem elas. */
          var extras = Array.prototype.map.call(raiz.querySelectorAll('[data-cupula-extra]:checked'), function (c) { return { id: +c.value, quantity: 1 }; });
          if (!r.ok || !extras.length) return r;
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: extras })
          }).then(function () { return r; }, function () { return r; });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add falhou');
          if (comprar) { location.href = window.Shopify.routes.root + 'cart'; return; }
          quem.disabled = false;
          /* 🪤 ABRIR NÃO REDESENHA — e ESTE arquivo é a origem do engano.
             Ele: *"os produtos não estão sendo adicionados direto ao carrinho
             quando clico em adicionar; depois, quando abro, estão lá"*. A
             gaveta abria com o HTML do carregamento da página, quando o
             carrinho ainda estava vazio.
             `cart:refresh` é a SAÍDA do `redesenha()` — quem escuta é o
             contador da sacola —, não a entrada. Quem repinta a gaveta pelo
             Liquid é `redesenha()`, e ele já dispara o `cart:refresh` no fim;
             disparar aqui também contaria o evento duas vezes.
             📏 Eu já tinha achado e consertado isto no `ettore-monte.js`, e o
               comentário de lá diz que copiei o par errado DAQUI. Consertei a
               cópia e deixei o original de pé por seis dias. Achar a origem
               faz parte do conserto. */
          var pronto = (typeof gaveta.redesenha === 'function')
            ? gaveta.redesenha()
            : Promise.resolve();
          return pronto.then(function () { gaveta.open(quem); });
        })
        .catch(function () { quem.disabled = false; form.submit(); });
    });

    /* ---- vídeo que só baixa quando chega perto — [2026-08-29] ----
       O vídeo da embalagem (431 KB) tinha `autoplay` e descia NA CARGA, com o
       bloco a milhares de pixels da dobra — era o maior download da página.
       Agora ele nasce `preload="none"` com poster, e o play (que dispara o
       download) sai daqui, meia tela antes de o bloco aparecer. Fora da tela,
       pausa — mesma economia que o tocaVideo() das abas já faz.
       🪤 O script roda nas DUAS seções; o vídeo mora numa só. `perto.length`
         vazio na outra metade é o caminho normal, não um erro. */
    var perto = raiz.querySelectorAll('video[data-toca-perto]');
    if (perto.length && 'IntersectionObserver' in window) {
      var obsV = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { rootMargin: '50% 0px' });
      perto.forEach(function (v) { obsV.observe(v); });
    } else {
      /* sem IO (raro hoje), volta ao comportamento antigo: toca direto */
      perto.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
    }
  }

  function tudo() {
    var marcas = document.querySelectorAll('[data-produto-js]');
    for (var i = 0; i < marcas.length; i++) {
      var raiz = marcas[i].previousElementSibling;
      if (raiz && !raiz.__ligado) { raiz.__ligado = true; liga(raiz); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
})();
